import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MessagesComponent } from './components/messages/messages.component';
import {MyDateRangePickerModule} from 'mydaterangepicker';
import { MarketwebsitesSmsComponent } from './components/marketwebsites-sms/marketwebsites-sms.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxDatatableModule,
    MyDateRangePickerModule,
  ],
  declarations: [
    MessagesComponent,
    MarketwebsitesSmsComponent
  ]
})
export class MessagesModule { }



// WEBPACK FOOTER //
// ./src/app/messages/messages.module.ts